<script>
import CarFeaturesList from "./ModalCarFeaturesList"

export default {
  name: 'CarFeatures',

  props: {
    car: {
      type: Object,
      required: true
    }
  },

  components: {
    CarFeaturesList
  },

  computed: {
    features () {
      const features = [
        // make sure to add an SVG icon for every new feature
        'has_range_extender',
        'has_seat_for_child',
        'tire_type',
        'has_navigation_system',
        'has_air_condition',
        'number_of_bags',
        'number_of_doors',
        'number_of_seats',
        'payload'
      ].filter( featureName =>
        this.car[`feature_${featureName}`]
      ).map( featureName => {
          return {
            name: featureName,
            value: this.car[`feature_${featureName}`]
          }
        }
      )

      if (this.car.transmission) {
        features.unshift({
          name: 'transmission',
          value: this.car.transmission
        })
      }

      if (this.car.fuel_type == 'electric') {
        features.unshift({
          name: 'ev',
          value: true
        })
      }

      return features
    },
  
    featureList () {
      if (!this.car.car_features || !this.car.car_features.length) return null
      return this.groupBy(this.car.car_features, 'category')
    },

    moreCarFeaturesButtonOptions () {
      return {
        class: [
          "moqo_link--button",
          "moqo_link--custom-color",
          "more-car-features__button"
        ],
        style: {
          backgroundColor: this.teamsiteConfig.color
        }
      }
    }
  },
  
  methods: {
    openFeatureModal () {
      this.openModal(CarFeaturesList, {
        props: {
          feature_list: this.featureList,
          car_name: this.car.car_model.model_name
        }
      })
    },

    groupBy (objectArray, property) {
      return objectArray.reduce(function (acc, obj) {
        const key = obj[property]

        if (!acc[key]) acc[key] = []

        acc[key].push(obj)

        return acc
      }, {})
    }
  }

}
</script>

<template>
  <div class="car-features">
    <div class="row small-up-2 medium-up-3 large-up-4">
      <car-feature v-for="feature in features" :feature="feature" :key="feature.name" class="column column-block"></car-feature>
    </div>

    <div v-if='featureList' class='more-car-features text-center'>
      <a v-bind='moreCarFeaturesButtonOptions' @click='openFeatureModal'>{{ $t('cars.all_features') }}</a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.car-features {
  margin-bottom: rem-calc(10);
  
  .more-car-features__button {
    cursor: pointer;
    padding: rem-calc(7);
    font-size: rem-calc(14);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CarFeatures.vue